import { useEffect } from "react";
import { useLocation } from "wouter";
import { getSupabase } from "@/lib/supabase";

export default function AuthCallback() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    const type = sessionStorage.getItem("_auth_callback_type");
    sessionStorage.removeItem("_auth_callback_type");

    let settled = false;
    let sub: { unsubscribe: () => void } | null = null;

    const go = (hasSession: boolean) => {
      if (settled) return;
      settled = true;
      if (sub) sub.unsubscribe();
      if (!hasSession) { setLocation("/login"); return; }
      setLocation(type === "recovery" || type === "invite" ? "/set-password" : "/");
    };

    const timer = setTimeout(() => go(false), 5000);

    (async () => {
      try {
        const supabase = await getSupabase();
        const code = new URLSearchParams(window.location.search).get("code");

        // Register listener before any async work so we never miss a state change.
        // Ignore null-session events (INITIAL_SESSION before detectSessionInUrl finishes).
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
          if (session) { clearTimeout(timer); go(true); }
        });
        sub = subscription;

        // If detectSessionInUrl already processed the hash, session is here now
        const { data: { session } } = await supabase.auth.getSession();
        if (session) { clearTimeout(timer); go(true); return; }

        // PKCE flow (OAuth / browser-initiated magic links)
        if (code) {
          const { error } = await supabase.auth.exchangeCodeForSession(code);
          if (error) { clearTimeout(timer); go(false); }
          // onAuthStateChange fires on success
          return;
        }

        // Otherwise: detectSessionInUrl is still processing the hash — onAuthStateChange will fire
      } catch {
        clearTimeout(timer);
        go(false);
      }
    })();

    return () => {
      settled = true;
      clearTimeout(timer);
      if (sub) sub.unsubscribe();
    };
  }, [setLocation]);

  return <div style={{ padding: 24 }}>Signing you in…</div>;
}
